<template>
  <div class="gis">
    <div class="gis-box">
      <div class="gis-content">
        <div class="gis-content-left">
          <div class="gis-content-one">资产地图可视化 \ 租金自动评估 \ 资产现状及收益分析</div>
          <div class="gis-content-two">GIS资产管理平台</div>
          <div class="gis-content-four" style=" margin-top: 30px;">围绕各政府单位及企业自有的资产信息，采用GIS地理信息技术</div>
          <div class="gis-content-four">实现资产数据可视化、资产管理智能化</div>
          <div class="client-btn" @click="toLogin">点击登录</div>
        </div>
        <div class="gis-content-right">
          <img src="../assets/img/zichan_001.png" />
        </div>
      </div>
    </div>
    <div class="gis-content-box">
      <div class="gis-one">
        <div class="gis-one-left" id="wrapper-text">
          <div class="gis-text-one">资产地图可视化</div>
          <div class="gis-text-two">Asset map visualization</div>
          <div class="gis-text-three" style="margin-top:30px">引入GIS地图技术，将资产数据与地图相结合，</div>
          <div class="gis-text-three">在地图上反映当前机构资产分布情况。</div>
        </div>
        <div class="gis-one-right" id="wrapper-img">
          <img src="../assets/img/zichan_01.png" />
        </div>
      </div>
      <div class="gis-two">
        <div class="gis-one-left" id="wrapper-text1">
          <div class="gis-text-one">租金自动评估</div>
          <div class="gis-text-two">Automatic rent assessment</div>
          <div class="gis-text-three" style="margin-top:30px">通过大数据分析对楼盘资产的租金进行自动估</div>
          <div class="gis-text-three">价。</div>
        </div>
        <div class="gis-one-right" id="wrapper-img1">
          <img src="../assets/img/zichan_02.png" />
        </div>
      </div>
      <div class="gis-three">
        <div class="gis-one-left" id="wrapper-text2">
          <div class="gis-text-one">资产现状及收益分析</div>
          <div class="gis-text-two">Analysis of Assets Status and Earnings</div>
          <div class="gis-text-three" style="margin-top:30px">根据不同的资产处置结果实时生成资产现状分</div>
          <div class="gis-text-three">析，形成资产收益分析结果。</div>
        </div>
        <div class="gis-one-right" id="wrapper-img2">
          <img src="../assets/img/zichan_03.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight gis-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft gis-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight gis-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft gis-one-left'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight gis-one-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft gis-one-left'
    );
  },
  methods: {
    toLogin() {
      window.open('https://zc.yunzhengshou.com/login');
    }
  }
};
</script>
<style>
.gis {
  width: 100%;
}
.gis-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.gis-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.gis-content-left,
.gis-content-right {
  width: 50%;
}
.gis-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
  margin-top: 100px;
}
.gis-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.gis-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.gis-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.gis-content-right img {
  width: 100%;
}
.gis-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.gis-one,
.gis-two,
.gis-three {
  display: flex;
  padding: 50px 80px;
  overflow: hidden;
}
.gis-text-one {
  margin-top: 96px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: rgb(73, 83, 98);
}
.gis-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 30px;
  color: #999999;
}
.gis-text-three {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.gis-one-left {
  padding-right: 150px;
  width: 50%;
}
.gis-one-right {
  width: 50%;
}
.gis-one-right img {
  margin-top: 50px;
}
.client-btn {
  width: 110px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  text-align: center;
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  cursor: pointer;
  margin-top: 42px;
}
.client-btn:hover {
  color: rgb(41, 146, 151);
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .gis-content,
  .gis-content-box {
    width: 1200px !important;
  }
  .gis-content-two {
    font-size: 48px !important;
  }
  .gis-one-left {
    padding-right: 50px !important;
  }
  .gis-text-one {
    font-size: 36px !important;
  }
  .gis-text-two {
    font-size: 28px !important;
  }
  .gis-text-three {
    font-size: 24px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/gis.vue